<div class="page-wrapper" *ngIf="isTranslationLoaded">
  <div class="header">
    <qai-inner-wrap>
      <h2 class="header_title">
        {{ "personalizedPractice.TITLE" | transloco }}
      </h2>
      <p class="header_description">
        {{
          "personalizedPractice.DESCRIPTION"
            | transloco : { userFirstName: userFirstName }
        }}
      </p>
    </qai-inner-wrap>
  </div>
  <app-personalized-product-list></app-personalized-product-list>
</div>
